/* LLRULE home: scroll reveal, product row arrows and progress bars, card hover cycling, home video */
(function(){
  if (window.__llrHome) return; window.__llrHome = true;
  var root = document.documentElement;
  var design = window.Shopify && Shopify.designMode;
  var reveal = !design;
  if (reveal) root.classList.add('llr-js');

  var io = ('IntersectionObserver' in window) ? new IntersectionObserver(function(entries){
    entries.forEach(function(e){ if (e.isIntersecting){ e.target.classList.add('is-in'); io.unobserve(e.target); } });
  }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 }) : null;

  /* Product card hover: same behavior as the theme cards (cycle images, or reveal the 2nd) */
  var canHover = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  function initCard(card){
    var style = card.getAttribute('data-llr-card');
    if (!canHover || style === 'none' || card.__llr) return; card.__llr = true;
    var media = card.querySelector('.llr-card__media');
    var delay = (parseFloat(card.getAttribute('data-delay')) || 1.5) * 1000;
    var pages = card.querySelectorAll('.llr-card__pages span');
    var timer = null, idx = 0, hydrated = false;
    function hydrate(){
      if (hydrated) return; hydrated = true;
      media.querySelectorAll('template[data-llr-img]').forEach(function(t){
        var img = t.content.firstElementChild; if (img) media.insertBefore(img.cloneNode(true), t); t.remove();
      });
    }
    function imgs(){ return media.querySelectorAll('.llr-card__img'); }
    function show(i){
      var list = imgs(); if (!list.length) return;
      idx = i % list.length;
      list.forEach(function(el, n){ el.classList.toggle('is-active', n === idx); });
      pages.forEach(function(p, n){
        p.classList.remove('is-on'); p.classList.toggle('is-done', n < idx);
        if (n === idx){ void p.offsetWidth; p.classList.add('is-on'); }
      });
    }
    card.addEventListener('mouseenter', function(){
      hydrate();
      if (style === 'second'){ show(1); return; }
      card.classList.add('is-cycling');
      show(1);
      clearInterval(timer);
      timer = setInterval(function(){ show(idx + 1); }, delay);
    });
    card.addEventListener('mouseleave', function(){
      clearInterval(timer); timer = null;
      card.classList.remove('is-cycling');
      show(0);
      pages.forEach(function(p){ p.classList.remove('is-on', 'is-done'); });
    });
  }

  function initSection(s){
    if (!s || s.__llr) return; s.__llr = true;
    s.querySelectorAll('[data-llr-card]').forEach(initCard);
    s.querySelectorAll('.llr-card, .llr-card img, .llr-cat, .llr-cat img').forEach(function(el){ el.setAttribute('draggable', 'false'); });
    s.addEventListener('dragstart', function(e){ if (e.target.closest('.llr-track, .llr-cats')) e.preventDefault(); });
    s.querySelectorAll('.llr-reveal').forEach(function(el){ if (io && reveal) io.observe(el); else el.classList.add('is-in'); });
    var t = s.querySelector('[data-llr-track]'); if (!t) return;
    s.querySelectorAll('.llr-arrow').forEach(function(b){
      b.addEventListener('click', function(){ t.scrollBy({ left: parseInt(b.dataset.dir, 10) * t.clientWidth * 0.9, behavior: 'smooth' }); });
    });
    var bar = s.querySelector('[data-llr-bar]');
    if (bar){
      var upd = function(){ var w = t.scrollWidth, v = t.clientWidth, p = w > v ? v / w : 1; bar.style.width = (p * 100) + '%'; bar.style.transform = 'translateX(' + (w > v ? (t.scrollLeft / (w - v)) * ((1 - p) / p) * 100 : 0) + '%)'; };
      t.addEventListener('scroll', upd, { passive: true }); window.addEventListener('resize', upd); upd();
    }
  }

  /* Home video: play while visible, and click through to the product row below it */
  function initVideos(){
    if (!document.body.classList.contains('template-index')) return;
    document.querySelectorAll('.shopify-section video').forEach(function(v){
      if (v.__llr) return; v.__llr = true;
      var sec = v.closest('.shopify-section');
      if (!v.closest('.aspect-video')) return;
      sec.classList.add('llr-video-sec');
      v.muted = true; v.setAttribute('playsinline', '');
      if ('IntersectionObserver' in window){
        new IntersectionObserver(function(es){ es.forEach(function(e){ if (e.isIntersecting){ var p = v.play(); if (p && p.catch) p.catch(function(){}); } else { v.pause(); } }); }, { threshold: 0.25 }).observe(v);
      }
      var next = sec.nextElementSibling, link = next && next.querySelector('.llr-all');
      if (link && !design){
        var a = document.createElement('a');
        a.href = link.getAttribute('href'); a.className = 'llr-video-link';
        a.setAttribute('aria-label', link.textContent.trim());
        v.parentElement.appendChild(a);
      }
    });
  }
  function initAll(){ document.querySelectorAll('[data-llr-section]').forEach(initSection); initVideos(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll); else initAll();
  document.addEventListener('shopify:section:load', function(e){ initSection(e.target.querySelector('[data-llr-section]')); initVideos(); });
})();